export default __webpack_public_path__ + "static/media/4.f0f47061.png";